import React from 'react';
import { Button } from 'antd';
import { ButtonProps as ButtonCopyProps } from 'antd/lib/button';

export type ButtonProps = ButtonCopyProps;

const ProButton: React.FC<ButtonProps> = React.forwardRef<any, ButtonProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Button ref={ref} {...resProps}>
        {children}
      </Button>
    );
  },
);

export default ProButton;
